import { useMemo } from "react"
import { useModelMetadata } from "resources/models"
import { SelectedInstrument } from "helpers/types/instruments/selected"

export function useDefaultSelectedBase(modelId: string, latestBase: SelectedInstrument | null): SelectedInstrument | null {
  const [modelMetadata] = useModelMetadata(modelId)

  return useMemo((): SelectedInstrument | null => {
    if (latestBase) {
      return latestBase
    } else if (modelMetadata) {
      return {
        type: "BENCHMARK",
        id: modelMetadata.defaultBenchmark,
      }
    }
    return null
  }, [modelMetadata, latestBase])
}
